import {BootstrapOptions, Injectable} from '@angular/core';
import {GritFilter} from "../../models/grit/grit.filter";
import {FeatureType} from "../../models/EnumTypes";
import {GritInterferenceTestService} from "./grit.interference-test.service";
import {PointsService} from "../points.service";
import {GlobalSelectionControlService} from "../../map/services/global-selection-control.service";
import {GritFeature} from "../../models/grit/grit.feature";
import {GritRadarService} from "./grit.radar.service";
import { GritOption } from 'src/app/models/grit/grit.model';
import {GritInputCondition} from "../../models/grit/grit.model";

export class FilterTab {
  featureType: FeatureType;
  filters : GritOption<GritInputCondition>[] = [];
  addedFilters : GritFilter[] = [];

  field = {index: 0, values: []};
  selected = {name : "", index : 0 };
  count = {filtered: 0, total: 0, };

  save: (filters: GritFilter[]) => boolean;
  reset: () => void;
  apply: (feature: GritFeature<any>, mode: FilterMode, result: boolean) => boolean;

  constructor(featureType: FeatureType, filters: GritOption<GritInputCondition>[], save: (filters: GritFilter[]) => boolean,
              reset: () => void, apply?: (feature: GritFeature<any>, mode: FilterMode, result: boolean) => boolean) {
    this.featureType = featureType;
    this.filters = filters;

    this.save = save;
    this.reset = reset;
    this.apply = apply;

  }

  get field_index(){ return this.field.index}
  set field_index(i : number){
    this.field.index = i;
    this.field.values = [];
  }

  get field_inputs(){return this.filters[this.field_index]?.value.inputs}

  get field_values() { return this.field.values;}

  selectFilter(name: string,  index: number){
    this.selected = {name : name, index : index };
  }

  isSelectedFilter(name: string, index: number){
    return this.selected.name == name && this.selected.index == index;
  }

  addFilter(){
    let optionInputCondition = this.filters[this.field.index] as GritOption<GritInputCondition>
    let filter = this.addedFilters.find(filter => filter.name === optionInputCondition.display);

    if(!filter){
      filter = new GritFilter(optionInputCondition.display);
      this.addedFilters.push(filter)
    }

    let conditions = optionInputCondition.value.condition(this.field_values);

    filter.conditions.push(conditions)
  }

  removeFilter(){
    let filterIndex = this.addedFilters.findIndex(filter => filter.name == this.selected.name);
    let filter = this.addedFilters[filterIndex];
    if (!filter) return;

    filter.conditions.splice(this.selected.index, 1)

    if(filter.conditions.length == 0){
      this.addedFilters.splice(filterIndex, 1)
    }

    this.selected = {name : "", index : 0 };
  }
}

export enum FilterMode{
  ONLY,
  SELECT,
}

@Injectable({
  providedIn: 'root'
})
export class GritFeatureFilterService {

  public tab = {
    active : false,
    loading : false,

    current : null as FilterTab,
  }

  constructor(
    private interferenceTestService : GritInterferenceTestService,
    private radarService : GritRadarService,
    private pointsService : PointsService,
    private globalSelectionControlService : GlobalSelectionControlService,
  ) { }

  //#region Tab
  toggleFilterTab(active: boolean, featureType: FeatureType = null){
    this.tab.active = active;

    if (!active) return;

    switch (featureType){
      case FeatureType.InterferenceTest :
        this.tab.current = this.interferenceTestService.filterTab;
        break;
      case FeatureType.Radar :
        this.tab.current = this.radarService.filterTab;
        break;
    }
  }

  applyFilterTab(mode: FilterMode){
    let current = this.tab.current;
    this.tab.loading = true;

    this.applyFilter(current.featureType, current.addedFilters , mode, this.tab.current.apply);

    this.tab.loading = false;

    if (mode == FilterMode.ONLY) current.save(current.addedFilters);
  }

  resetFilterTab(){
    let current = this.tab.current;

    current.addedFilters = [];

    // this.filterCount = null;
    if (this.tab.current.reset) this.tab.current.reset()
    current.save(current.addedFilters);
  }
  //endregion

  applyFilter(featureType: FeatureType, filters: GritFilter[], mode: FilterMode,
              apply?: (feature: GritFeature<any>, mode: FilterMode, result: boolean) => boolean){

    let features = this.pointsService.getGritFeatures(featureType);

    features.forEach(feature => {
      let entity = feature.entity;

      let result = true;
      for (let filter of filters){
        result &&= filter.apply(entity)
        if(!result) break;
      }

      if (apply && apply(feature, mode, result)) return;

      if(mode == FilterMode.ONLY && !result) {
        feature.layer.getSource().removeFeature(feature);
        this.globalSelectionControlService.removeSelectedFeature(feature);
      }
      else if (mode == FilterMode.SELECT && result){
        this.globalSelectionControlService.setSelectedFeature(feature.layer, feature)
      }
      else{
        this.globalSelectionControlService.removeSelectedFeature(feature)
      }
    })

  }
}
